var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms"},[_c('transition',{attrs:{"name":"auth-router","mode":"out-in"}},[_c('router-view',{staticClass:"router"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }